import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps, PrismicRichText } from "@prismicio/react";
import { PrismicNextLink, PrismicNextImage } from '@prismicio/next'

/**
 * Props for `IconGrid`.
 */
export type IconGridProps = SliceComponentProps<Content.IconGridSlice>;

/**
 * Component for "IconGrid" Slices.
 */
const IconGrid: FC<IconGridProps> = ({ slice }) => {

  const colSettings = slice.primary.column_setting === true ? "col-span-12 md:col-span-6 lg:col-span-3" : "col-span-12 md:col-span-4";

  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className={`${slice.primary.background.toLowerCase()} w-screen px-4 md:px-8 pb-24`}
    >
      <div className={`max-w-[1280px] mx-auto font-fellix text-jade`}>
          {slice.primary.heading?.length > 0 ?
            <div className="text-center w-full max-w-[650px] mx-auto pt-24">
              <article className="mb-12">
                <PrismicRichText field={slice.primary.heading} />
              </article>
              {slice.primary.description?.[0] ? 
              <article className="text-[28px] leading-[36px] mb-12">
                <PrismicRichText field={slice.primary.description} />
              </article>
              :<></>}
            </div>
          : <></>}
          <div className="grid grid-cols-12 gap-0 w-full">
            {slice.primary.grid_items.map((item: any, index: any)=>{
              return (
                <div className={`${colSettings} flex justify-center pb-16`} key={index}>
                  <div className="text-center max-w-[300px] w-full">
                    {item.link.link_type !=="Any" ? 
                    <PrismicNextLink field={item.link}>
                      <div className="h-[100px] mb-2">
                        <PrismicNextImage field={item.icon} fallbackAlt="" className="mx-auto w-full max-h-[90px]"/>
                      </div>
                      {item.icon_title?.[0] ? 
                      <p className="text-[20px] leading-[24px] font-semibold mb-4 pt-6">
                        {item.icon_title}
                      </p>
                      :<></>}
                      {item.description?.[0] ? 
                      <article className="text-[20px] leading-[24px]">
                        <PrismicRichText field={item.description} />
                      </article>
                      :<></>}
                    </PrismicNextLink>
                    :
                    <PrismicNextLink field={item.link}>
                      <div className="h-[100px] mb-2">
                        <PrismicNextImage field={item.icon} fallbackAlt="" className="mx-auto w-full max-h-[90px]"/>
                      </div>
                      {item.icon_title?.[0] ? 
                      <p className="text-[20px] leading-[24px] font-semibold mb-4">
                        {item.icon_title}
                      </p>
                      :<></>}
                      {item.description?.[0] ? 
                      <article className="text-[18px] leading-[24px]">
                        <PrismicRichText field={item.description} />
                      </article>
                      :<></>}
                    </PrismicNextLink>  
                    }
                  </div>
                </div>
              )
            })}
          </div>
        </div>
    </section>
  );
};

export default IconGrid;
